import React, { useEffect, useState } from 'react';
import { Breadcrumb, Layout, theme, Row, Col, Form, Button, Modal, Input, Typography, Table, Tag, Space, Switch, Tooltip } from 'antd';
import { EditOutlined, UnorderedListOutlined } from '@ant-design/icons';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { useNavigate } from "react-router-dom";
import { MAINAPIURL,APPBACKGROUND_COLOR } from '../appsettings.js';
import axios from 'axios';
import { AlertError, AlertSuccess } from '../usableclasses.js';
const { Content } = Layout;


function Stocks() {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();

   
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [stocks, setStocks] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editStock, setEditStock] = useState(null);
    const [filteredStocks, setFilteredStocks] = useState([]);
    const [keyword, setKeyword] = useState('');
    const [selectedStock, setSelectedStock] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        fetchStocks();
        
    }, []);

    const fetchStocks = async () => {
        try {
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/stocks/all`, { headers });
            setStocks(response.data);
            setFilteredStocks(response.data);
        } catch (error) {
            AlertError("Failed to Load Stock");
        }
    };

 
    const showModal = () => {
        setIsModalOpen(true);
    };
    const showEditModal = (stock) => {
        setEditStock(stock);
        form.setFieldsValue({
            // stockCode: stock.stockCode,
            stockName: stock.stockName,
            stockActiveStatus: stock.stockActive === "True",
        });
        setIsEditModalOpen(true);
    };
    
    const handleCancel = () => {
        setIsModalOpen(false);
        setIsEditModalOpen(false);
        form.resetFields();
    };

    
    const handleCreateStock = async () => {
        try {
            const values = await form.validateFields();

            const requestData = {
                //stockCode: values.stockCode,
                stockName: values.stockName,
            };

            const headers = {
                SystemAccessToken: TOKEN,
                "Content-Type": "application/json",
            };

            const response = await axios.post(
                `${ApiURL}/stocks/create`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("Stocks successfully added!");
                handleCancel();
                fetchStocks();
            }
        } catch (error) {
            AlertError(error.response?.data?.message || "Failed to add Stock!");
        }
    };
    const handleUpdateStock = async () => {
        try {
            const values = await form.validateFields();
            const requestData = {
                stockId: editStock.stockId,
                stockName: values.stockName,
                stockActiveStatus: values.stockActiveStatus,
            };

            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.post(
                `${ApiURL}/stocks/edit`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("Stock successfully updated!");
                handleCancel();
                fetchStocks();
            }
        } catch (error) {
            AlertError(error.response?.data?.message || "Failed to update stock!");
        }
    };
    
    const handleFilter = () => {
        let filtered = stocks;

        if (selectedStock) {
            filtered = filtered.filter(stock => stock.stockId === selectedStock);
        }

        if (keyword) {
            filtered = filtered.filter(stock => stock.stockName.toLowerCase().includes(keyword.toLowerCase()));
        }

        setFilteredStocks(filtered);
    };

   
    const handleReset = () => {
        setKeyword('');
        setSelectedStock(null);
        setFilteredStocks(stocks);
    };

    const handleViewSubstocks = (stockId) => {
        const selectedStock = stocks.find(cat => cat.stockId === stockId);
        if (selectedStock && selectedStock.stockName) {
            localStorage.setItem(`stockName_${stockId}`, selectedStock.stockName);
        }

        navigate(`/stocks/itemsmanagment/${stockId}`);
    };

    const columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            fixed: 'left',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Tooltip title="Stock Items">
                        <Button 
                            type="link" 
                            icon={<UnorderedListOutlined />} 
                            onClick={() => handleViewSubstocks(record.stockId)}
                        />
                    </Tooltip>
                    <Tooltip title="Edit">
                        <Button type="link" icon={<EditOutlined />} onClick={() => showEditModal(record)} />
                    </Tooltip>
                    
                    {/* <Popconfirm
                        title="Are you sure to delete this stock?"
                        onConfirm={() => handleDeleteStock(record.stockId)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Tooltip title="Delete">
                            <Button type="link" danger icon={<DeleteOutlined />} />
                        </Tooltip>
                    </Popconfirm> */}
                </Space>
            ),
        },
        {
            title: 'Stock Name',
            dataIndex: 'stockName',
            key: 'stockName',
            sorter: (a, b) => a.stockName.localeCompare(b.stockName),
            align: "center",
        },
        {
            title: 'Status',
            dataIndex: 'stockActive',
            key: 'stockActive',
            render: (stockActive) => (
                <Tag color={stockActive === "True" ? "green" : "red"}>
                    {stockActive === "True" ? "Active" : "Inactive"}
                </Tag>
            ),
            align: "center",
        },
    ];
    return (
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
            <Headerdiv />
            <Content style={{ padding: '10px', }} >
                <Breadcrumb style={{ margin: "16px 0" }}>
                    <Breadcrumb.Item>Stocks Management</Breadcrumb.Item>
                </Breadcrumb>
                <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG, }} >
                    <Space
                        direction="vertical"
                        style={{ width: "100%", padding: "15px" }}
                    >
                        <Row>
                            <Col xs={24} style={{ textAlign: "right",marginBottom:'20px' }}>
                                <Button type="primary" onClick={showModal}>Create New</Button>
                            </Col>

                        </Row>
                        <Row style={{display:"flex",justifyContent:'space-between'}}>
                       
                                {/* <Col xs={24} md={12}>
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder="Select Stock"
                                        value={selectedStock}
                                        onChange={setSelectedStock}
                                    >
                                        <Option value={null}>All Stocks</Option>
                                        {dropdownStocks.map((stock) => (
                                            <Option key={stock.id} value={stock.id}>{stock.label}</Option>
                                        ))}
                                    </Select>
                                </Col> */}
                                <Col xs={24} md={12}>
                                    <Input
                                        placeholder="Search by keyword"
                                        value={keyword}
                                        onChange={(e) => setKeyword(e.target.value)}
                                    />
                                </Col>
                                <Col xs={24} md={8} style={{display:"flex",justifyContent:'flex-end',justifySelf:'flex-end',}}>
                                    <Button type="primary" onClick={handleFilter} style={{ width: "50%",margin:"0" }} >Filter</Button>
                                    <Button style={{ marginLeft: '10px' ,width: "50%"}} onClick={handleReset}>Reset</Button>
                                </Col>


                            

                        </Row>
                        <Typography.Title level={5}>List of Stocks</Typography.Title>
                        <Table
                            columns={columns}
                            dataSource={filteredStocks}
                            rowKey="stockId"
                            pagination={{ pageSize: 5 }}
                            scroll={{ x: 600 }}
                        />

                    </Space>
                </div>
            </Content>
            <Footerdiv />
            <Modal
                title="Create New Stock"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="create" type="primary" onClick={handleCreateStock}>
                        Create
                    </Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    {/* <Form.Item
                        label="Stock Code"
                        name="stockCode"
                        rules={[
                            { required: true, message: "Stock code is required" },
                            { len: 4, message: "Stock code must be exactly 4 characters" },
                        ]}
                    >
                        <Input maxLength={4} />
                    </Form.Item> */}

                    <Form.Item
                        label="Stock Name"
                        name="stockName"
                        rules={[{ required: true, message: "Stock name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Edit Stock"
                open={isEditModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
                    <Button key="update" type="primary" onClick={handleUpdateStock}>Update</Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    {/* <Form.Item
                        label="Stock Code"
                        name="stockCode"
                        rules={[{ required: true, message: "Stock code is required" }, { len: 4, message: "Stock code must be exactly 4 characters" }]}
                    >
                        <Input maxLength={4} />
                    </Form.Item> */}
                    <Form.Item
                        label="Stock Name"
                        name="stockName"
                        rules={[{ required: true, message: "Stock name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Active Status"
                        name="stockActiveStatus"
                        valuePropName="checked"
                    >
                        <Switch defaultChecked={editStock?.stockActive === "True"} />
                    </Form.Item>
                </Form>
            </Modal>
            
        </Layout>
    );
}

export default Stocks;